import swFormEditor from './components/editor/sw-form-editor.vue'
import swItemEditorDate from './components/editor/sw-item-editor-date.vue'
import swItemEditorDatetime from './components/editor/sw-item-editor-datetime.vue'
import swItemEditorFile from './components/editor/sw-item-editor-file.vue'
import swItemEditorFullname from './components/editor/sw-item-editor-fullname.vue'
import swItemEditorLabel from './components/editor/sw-item-editor-label.vue'
import swItemEditorLink from './components/editor/sw-item-editor-link.vue'
import swItemEditorLongText from './components/editor/sw-item-editor-long-text.vue'
import swItemEditorMailaddress from './components/editor/sw-item-editor-mailaddress.vue'
import swItemEditorMultiSelect from './components/editor/sw-item-editor-multi-select.vue'
import swItemEditorNumeric from './components/editor/sw-item-editor-numeric.vue'
import swItemEditorPassword from './components/editor/sw-item-editor-password.vue'
import swItemEditorPhonenumber from './components/editor/sw-item-editor-phonenumber.vue'
import swItemEditorPicture from './components/editor/sw-item-editor-picture.vue'
import swItemEditorPulldown from './components/editor/sw-item-editor-pulldown.vue'
import swItemEditorShortText from './components/editor/sw-item-editor-short-text.vue'
import swItemEditorSign from './components/editor/sw-item-editor-sign.vue'
import swItemEditorSingleSelect from './components/editor/sw-item-editor-single-select.vue'
import swItemEditorSwitch from './components/editor/sw-item-editor-switch.vue'
import swItemEditorTable from './components/editor/sw-item-editor-table.vue'
import swItemEditorTime from './components/editor/sw-item-editor-time.vue'
import swItemEditorUrl from './components/editor/sw-item-editor-url.vue'
import swItemEditor from './components/editor/sw-item-editor.vue'
import swItemType from './components/editor/sw-item-type.vue'
import swFormInputter from './components/inputter/sw-form-inputter.vue'
import swItemInputter from './components/inputter/sw-item-inputter.vue'
import swLanguage from './components/lib/sw-language.js'
import swSchmeType from './components/lib/sw-schema-type.js'
import swItemPartsCanvas from './components/parts/sw-item-parts-canvas.vue'
import swItemPartsCheckbox from './components/parts/sw-item-parts-checkbox.vue'
import swItemPartsColumns from './components/parts/sw-item-parts-columns.vue'
import swItemPartsDate from './components/parts/sw-item-parts-date.vue'
import swItemPartsDatetime from './components/parts/sw-item-parts-datetime.vue'
import swItemPartsFile from './components/parts/sw-item-parts-file.vue'
import swItemPartsFullname from './components/parts/sw-item-parts-fullname.vue'
import swItemPartsLabel from './components/parts/sw-item-parts-label.vue'
import swItemPartsLink from './components/parts/sw-item-parts-link.vue'
import swItemPartsMailaddress from './components/parts/sw-item-parts-mailaddress.vue'
import swItemPartsMarkdown from './components/parts/sw-item-parts-markdown.vue'
import swItemPartsNumeric from './components/parts/sw-item-parts-numeric.vue'
import swItemPartsPassword from './components/parts/sw-item-parts-password.vue'
import swItemPartsPhonenumber from './components/parts/sw-item-parts-phonenumber.vue'
import swItemPartsPicture from './components/parts/sw-item-parts-picture.vue'
import swItemPartsRadioBool from './components/parts/sw-item-parts-radio-bool.vue'
import swItemPartsRadioCheck from './components/parts/sw-item-parts-radio-check.vue'
import swItemPartsRadio from './components/parts/sw-item-parts-radio.vue'
import swItemPartsSelect from './components/parts/sw-item-parts-select.vue'
import swItemPartsSwitch from './components/parts/sw-item-parts-switch.vue'
import swItemPartsTable from './components/parts/sw-item-parts-table.vue'
import swItemPartsText2 from './components/parts/sw-item-parts-text-2.vue'
import swItemPartsText from './components/parts/sw-item-parts-text.vue'
import swItemPartsTextarea from './components/parts/sw-item-parts-textarea.vue'
import swItemPartsTime from './components/parts/sw-item-parts-time.vue'
import swItemPartsUrl from './components/parts/sw-item-parts-url.vue'
import swFormViewer from './components/viewer/sw-form-viewer.vue'
import swItemViewerFile from './components/viewer/sw-item-viewer-file.vue'
import swItemViewerFullname from './components/viewer/sw-item-viewer-fullname.vue'
import swItemViewerHtml from './components/viewer/sw-item-viewer-html.vue'
import swItemViewerLabel from './components/viewer/sw-item-viewer-label.vue'
import swItemViewerMultiline from './components/viewer/sw-item-viewer-multiline.vue'
import swItemViewerPassword from './components/viewer/sw-item-viewer-password.vue'
import swItemViewerPicture from './components/viewer/sw-item-viewer-picture.vue'
import swItemViewerTable from './components/viewer/sw-item-viewer-table.vue'
import swItemViewerText from './components/viewer/sw-item-viewer-text.vue'
import swItemViewerTexts from './components/viewer/sw-item-viewer-texts.vue'
import swItemViewerUrl from './components/viewer/sw-item-viewer-url.vue'
import swItemViewer from './components/viewer/sw-item-viewer.vue'
import swListViewer from './components/viewer/sw-list-viewer.vue'

// Named export
export {
  swFormEditor,
  swItemEditorDate,
  swItemEditorDatetime,
  swItemEditorFile,
  swItemEditorFullname,
  swItemEditorLabel,
  swItemEditorLink,
  swItemEditorLongText,
  swItemEditorMailaddress,
  swItemEditorMultiSelect,
  swItemEditorNumeric,
  swItemEditorPassword,
  swItemEditorPhonenumber,
  swItemEditorPicture,
  swItemEditorPulldown,
  swItemEditorShortText,
  swItemEditorSign,
  swItemEditorSingleSelect,
  swItemEditorSwitch,
  swItemEditorTable,
  swItemEditorTime,
  swItemEditorUrl,
  swItemEditor,
  swItemType,
  swFormInputter,
  swItemInputter,
  swLanguage,
  swSchmeType,
  swItemPartsCanvas,
  swItemPartsCheckbox,
  swItemPartsColumns,
  swItemPartsDate,
  swItemPartsDatetime,
  swItemPartsFile,
  swItemPartsFullname,
  swItemPartsLabel,
  swItemPartsLink,
  swItemPartsMailaddress,
  swItemPartsMarkdown,
  swItemPartsNumeric,
  swItemPartsPassword,
  swItemPartsPhonenumber,
  swItemPartsPicture,
  swItemPartsRadioBool,
  swItemPartsRadioCheck,
  swItemPartsRadio,
  swItemPartsSelect,
  swItemPartsSwitch,
  swItemPartsTable,
  swItemPartsText2,
  swItemPartsText,
  swItemPartsTextarea,
  swItemPartsTime,
  swItemPartsUrl,
  swFormViewer,
  swItemViewerFile,
  swItemViewerFullname,
  swItemViewerHtml,
  swItemViewerLabel,
  swItemViewerMultiline,
  swItemViewerPassword,
  swItemViewerPicture,
  swItemViewerTable,
  swItemViewerText,
  swItemViewerTexts,
  swItemViewerUrl,
  swItemViewer,
  swListViewer
};

// Default export
export default {
  swFormEditor,
  swItemEditorDate,
  swItemEditorDatetime,
  swItemEditorFile,
  swItemEditorFullname,
  swItemEditorLabel,
  swItemEditorLink,
  swItemEditorLongText,
  swItemEditorMailaddress,
  swItemEditorMultiSelect,
  swItemEditorNumeric,
  swItemEditorPassword,
  swItemEditorPhonenumber,
  swItemEditorPicture,
  swItemEditorPulldown,
  swItemEditorShortText,
  swItemEditorSign,
  swItemEditorSingleSelect,
  swItemEditorSwitch,
  swItemEditorTable,
  swItemEditorTime,
  swItemEditorUrl,
  swItemEditor,
  swItemType,
  swFormInputter,
  swItemInputter,
  swLanguage,
  swSchmeType,
  swItemPartsCanvas,
  swItemPartsCheckbox,
  swItemPartsColumns,
  swItemPartsDate,
  swItemPartsDatetime,
  swItemPartsFile,
  swItemPartsFullname,
  swItemPartsLabel,
  swItemPartsLink,
  swItemPartsMailaddress,
  swItemPartsMarkdown,
  swItemPartsNumeric,
  swItemPartsPassword,
  swItemPartsPhonenumber,
  swItemPartsPicture,
  swItemPartsRadioBool,
  swItemPartsRadioCheck,
  swItemPartsRadio,
  swItemPartsSelect,
  swItemPartsSwitch,
  swItemPartsTable,
  swItemPartsText2,
  swItemPartsText,
  swItemPartsTextarea,
  swItemPartsTime,
  swItemPartsUrl,
  swFormViewer,
  swItemViewerFile,
  swItemViewerFullname,
  swItemViewerHtml,
  swItemViewerLabel,
  swItemViewerMultiline,
  swItemViewerPassword,
  swItemViewerPicture,
  swItemViewerTable,
  swItemViewerText,
  swItemViewerTexts,
  swItemViewerUrl,
  swItemViewer,
  swListViewer
};

